



import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import styled from "styled-components"
import { showNestedModal } from "../../features/modal/modalSlice"
import PageTopTitle from "../shared/PageTopTitle"
import Button from "../shared/Button"
import { updateGarajStats } from "../../features/admin/adminSlice"
import Btn from "../shared/button/Btn"

const ModalContainer = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 26;

    .modal{
        width: 1000px;
        height: auto;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        padding-top: 20px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        justify-content: center;

        .content{
            margin-top: 20px;
            padding: 0 20px;
            width: 100%;
            min-height: 350px;
            display: flex;
            flex-direction: column;
            align-items: center;

            .top-container{
                width: 100%;
                display: flex;
                justify-content: space-between;
                /* align-items: center; */
                border: 1px solid ${({ theme }) => theme.mainTextColor};
                border-radius: 10px;
                padding: 10px 20px;

                .placeholder{
                    width: 172px;
                }

                .garaj-ismi{
                    font-size: var(--font-size-md);
                    font-weight: var(--font-weight-xl);
                }

                .latest-update{
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    font-weight: var(--font-weight-xl);

                    .text{
                        padding-bottom: 5px;
                    }


                    .underline{
                        border-bottom: 1px solid ${({ theme }) => theme.mainTextColor};
                        margin-bottom: 5px;
                        padding-bottom: 2px;
                    }

                }


            }

            .item-list{
                width: 60%;
                display: flex;
                flex-direction: column;
                padding-top: 40px;
                gap: 30px;


                .item{
                    display: flex;
                    align-items: center;

                    .label{
                        margin-right: 10px;
                        width: 130px;
                    }

                    input{
                        width: 50px;
                        text-align: center;
                        padding: 10px;
                        background-color: transparent;
                        border: 1px solid ${({ theme }) => theme.mainBorderColor};
                        border-radius: 5px;
                        font-variant-numeric: lining-nums;
                    }
                    .percent{
                        font-size: var(--font-size-md);
                        font-weight: var(--font-weight-xl); 
                        margin-right: 10px;
                    }

                    .line-container{
                        margin-left: 20px;
                    }
                }

            }
        }

        .button-grp{
            width: 100%;
            height: 80px;
            display: flex;
            justify-content: center;
            align-items: center;
        }
    }
`

const Line = styled.div`
  width: 180px;
  height: 12px;
  margin-right: 20px;

  .line{
    height: 100%;
    border-radius: 8px;
    display: flex;
    justify-content: space-between;
    background: linear-gradient(to right, green, yellow, red);


    .inner{
      transition: 1s;
      height: 100%;
      width: ${({sizeInner}) => sizeInner};
      background-color: transparent;
    }

    .upper{
      transition: 1s;
      width: ${({sizeUpper}) => sizeUpper};
      background-color: grey;
      background-color:  ${({ theme }) => theme.scrollThumbColor};
      height: 100%;
    }
  }
`

const AddGarajYogunlukEntryModal = () => {

    const {garajItemData} = useSelector(state => state.admin)

    const [aracYogunluk, setAracYogunluk] = useState(garajItemData[0].vehicleDensity)
    const [yukYogunluk, setYukYogunluk] = useState(garajItemData[0].loadDensity)

    const [messageYuk, setMessageYuk] = useState("")
    const [messageArac, setMessageArac] = useState("")



    const dispatch = useDispatch()
    const onlyNumbers = /^[0-9]*$/;


    //! burada validation mesajlarını kapattım ileride eklenebilir belki
    const handleChange = (e, type) => {
        const value = e.target.value
        if(value < 0 || value > 100){
            if(type === "yuk"){
                setMessageYuk("Girilen değer 0 dan küçük, 100 den büyük olamaz.")
            }
            if(type === "arac"){
                setMessageArac("Girilen değer sadece sayısal olabilir.")
            }
        }

        if(onlyNumbers.test(value) && (value >= 0) && (value <= 100)){
            if(type === "yuk"){
                setYukYogunluk(value)
            }

            if(type === "arac"){
                setAracYogunluk(value)
            }    
            
            setMessageYuk("")
            setMessageArac("")
        }
    }

    const handleClick = () => {
        const { time, entryTime, ...item } = garajItemData[0];
        dispatch(updateGarajStats({...item, vehicleDensity: parseInt(aracYogunluk), loadDensity: parseInt(yukYogunluk)}))

        dispatch(showNestedModal(null))
    }


  return (
    <ModalContainer onClick={()=> dispatch(showNestedModal(null))}>
        <div className="modal" onClick={(e) => e.stopPropagation()}>
            <PageTopTitle title={"Adres Seçimi"}/>
            <div className="content">
                <div className="top-container">
                    <div className="placeholder"></div>
                    <div className="garaj-ismi">{garajItemData[0].branchName} Kamyon Garajı</div>
                    <div className="latest-update">
                        <div className="text">Son Güncelleme Tarihi</div>
                        <div className="underline">{garajItemData[0].entryTime} </div>
                        <div className="underline">{garajItemData[0].time}</div>
                    </div>
                </div>
                <div className="item-list">
                    <div className="item">
                        <div className="label">Yük Yoğunluğu:</div>
                        <div className="percent">%</div>
                        <input type="text" value={yukYogunluk} onChange={(e) => handleChange(e, "yuk")}/>
                        <div className="line-container">
                            <Line sizeInner={`${yukYogunluk || 0}%`} sizeUpper={`${100 - (yukYogunluk || 0)}%`}>
                                <div className="line">
                                    <div className="inner"></div>
                                    <div className="upper"></div>
                                </div>
                            </Line>
                         </div>

                        {/* {
                            messageYuk &&
                            <div>{messageYuk}</div>
                        } */}
                    </div>
                    <div className="item">
                        <div className="label">Araç Yoğunluğu:</div>
                        <div className="percent">%</div>
                        <input type="text" value={aracYogunluk} onChange={(e) => handleChange(e, "arac")}/>
                        <div className="line-container">
                            <Line sizeInner={`${aracYogunluk || 0}%`} sizeUpper={`${100 - (aracYogunluk || 0)}%`}>
                                <div className="line">
                                    <div className="inner"></div>
                                    <div className="upper"></div>
                                </div>
                            </Line>
                         </div>

                        {/* {
                            messageArac &&
                            <div>{messageArac}</div>
                        } */}

                    </div>
                </div>
            </div>
            <div className='button-grp'>
                <Btn color={"#E85446"} bgColor={"transparent"} width="310px" handleClick={handleClick} >Kaydet</Btn>
            </div>
        </div>
    </ModalContainer>
  )
}

export default AddGarajYogunlukEntryModal